import { currencyTable } from "./currency-table.ts";

/** Derived from the table, never restated — the shape cannot drift from the data. */
export type CurrencyEntry = (typeof currencyTable)[keyof typeof currencyTable];

/** The `as const` table infers literal keys, so a lookup by a plain string needs
 *  the table widened. Doing it here once is what keeps the cast out of call sites. */
const CURRENCIES: Readonly<Record<string, CurrencyEntry | undefined>> =
  currencyTable;

/** Shown when a money field names no currency, or names one not in the table. */
export const DEFAULT_CURRENCY_SYMBOL = "$";

/** Every key in the table is lowercase, and a stored code is not normalized.
 *  Lowercasing here is what makes a stored `"USD"` resolve — without it the
 *  money format check silently falls back to "accept anything". */
export function currency(
  code: string | null | undefined,
): CurrencyEntry | undefined {
  return code ? CURRENCIES[code.toLowerCase()] : undefined;
}

export function currencySymbol(code: string | null | undefined): string {
  return currency(code)?.symbol ?? DEFAULT_CURRENCY_SYMBOL;
}

/** Picker options, in the table's declaration order. */
export const CURRENCY_OPTIONS: readonly { value: string; label: string }[] =
  Object.entries(CURRENCIES).map(([value, entry]) => ({
    value,
    label: entry!.label,
  }));
